import { type ArrayElement } from 'dibs-ts-utils/exports/ArrayElement.ts';
import {
    type MediaItemPhoto,
    type MediaItemVideo,
    type MediaItemViewInRoom,
} from 'dibs-image-utils/exports/useItemMediaItems.ts';

import { type PdpRespHeroCarousel_item$data } from './__generated__/PdpRespHeroCarousel_item.graphql.ts';

type SortedPhotos = NonNullable<ArrayElement<PdpRespHeroCarousel_item$data['sortedPhotos']>>[];
type ViewInRoomPhotos = NonNullable<
    ArrayElement<PdpRespHeroCarousel_item$data['viewInRoomPhotos']>
>[];

type CarouselItemPhoto = MediaItemPhoto<SortedPhotos>;
type CarouselItemVideo = MediaItemVideo<PdpRespHeroCarousel_item$data['videoVimeo']>;
type CarouselItemViewInRoom = MediaItemViewInRoom<ViewInRoomPhotos>;
type CarouselItemRequestMore = { __type: 'requestMore' };

export type CarouselItem =
    | CarouselItemPhoto
    | CarouselItemVideo
    | CarouselItemViewInRoom
    | CarouselItemRequestMore;

export const isPhoto = (item: CarouselItem): item is CarouselItemPhoto =>
    '__typename' in item && item.__typename === 'ItemPhoto';
